import moment from 'moment';

import { TimeSlotsType } from '@features/tables/schemas/TablesAvailability.schema';

import { isOverlapping } from './isTimeslotOverlapping';
import { resolveLeaveTime } from './packageDiningMenus';

type GuestExperience = { bookings?: unknown[] } | null | undefined;

const DEFAULT_MEAL_MINUTES = 90;

const toMinutesOfDay = (time: string | null | undefined) => {
  const match = time?.match(/(\d{1,2}):(\d{2})/);
  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
};

const getMealMinutes = (timeSlot: TimeSlotsType[number], menuId?: string | null) => {
  const start = toMinutesOfDay(timeSlot.timeSlot.split('T')[1]);
  const end = toMinutesOfDay(resolveLeaveTime(timeSlot, menuId));

  return start !== null && end !== null && end > start ? end - start : 0;
};

export function getBookingsForDay(experiences: unknown, dayNumber: number) {
  if (!Array.isArray(experiences)) {
    return [];
  }

  return (experiences as GuestExperience[])
    .filter((experience) => Array.isArray(experience?.bookings))
    .flatMap((experience) => experience?.bookings ?? [])
    .filter((booking: any) => booking && booking.dayNumber === dayNumber);
}

export function filterTimeslotsByExperiences(
  timeSlots: TimeSlotsType,
  {
    experiences,
    visitDate,
    dayNumber,
    delayAfter = 0,
    menuId,
  }: {
    experiences: unknown;
    visitDate?: string;
    dayNumber: number;
    delayAfter?: number;
    menuId?: string | null;
  }
): TimeSlotsType {
  const bookings = getBookingsForDay(experiences, dayNumber);

  if (!bookings.length || !visitDate) {
    return timeSlots;
  }

  return timeSlots.filter((timeSlot) => {
    const start = moment(timeSlot.timeSlot);
    const end = moment.min(
      start.clone().add(getMealMinutes(timeSlot, menuId) || DEFAULT_MEAL_MINUTES, 'minutes'),
      start.clone().endOf('day')
    );
    const mealStart = {
      visitDate,
      startTime: start.format('HH:mm'),
      endTime: start.format('HH:mm'),
      delayAfter,
      dayNumber,
    };
    const meal = {
      ...mealStart,
      endTime: end.format('HH:mm'),
      delayAfter: 0,
    };

    return !bookings.some(
      (booking: any) => isOverlapping(mealStart, booking) || isOverlapping(meal, booking)
    );
  });
}
